"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_PlanDefinition_Condition = exports.PlanDefinition_ConditionKindKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Expression_1 = require("./RTTI_Expression");
var PlanDefinition_ConditionKindKind;
(function (PlanDefinition_ConditionKindKind) {
    PlanDefinition_ConditionKindKind["_applicability"] = "applicability";
    PlanDefinition_ConditionKindKind["_start"] = "start";
    PlanDefinition_ConditionKindKind["_stop"] = "stop";
})(PlanDefinition_ConditionKindKind = exports.PlanDefinition_ConditionKindKind || (exports.PlanDefinition_ConditionKindKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_PlanDefinition_Condition = t.recursion('IPlanDefinition_Condition', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        kind: (0, EnumType_1.createEnumType)(PlanDefinition_ConditionKindKind, 'PlanDefinition_ConditionKindKind'),
        _kind: RTTI_Element_1.RTTI_Element,
        expression: RTTI_Expression_1.RTTI_Expression
    });
});
//# sourceMappingURL=RTTI_PlanDefinition_Condition.js.map